import React from "react";

const ColorBlock = ({ color, animationDelay, height }) => {
  return (
    <div
      style={{
        width: 0,
        backgroundColor: color,
        animationDelay: `${animationDelay}s`,
        animationDuration: "0.5s",
        animationFillMode: "forwards",
        animationName: "goRight",
        height: `${height}%`,
      }}
      key={color}
    ></div>
  );
};

export default ColorBlock;
